import { api } from "@/features/utils/fetch-server";
import type { UsersType } from "../types";

// AML Data Types
export interface AmlData {
  occupation?: string;
  business_sector?: string;
  hold_position?: string;
  source_of_funds?: string;
  annual_income?: string;
  estimated_transaction_frequency?: string;
  estimated_transaction_volume_per_year?: string;
  political_affiliations?: string;
  political_affiliations_other?: string;
  financial_crimes?: string;
  information_is_correct?: boolean;
  no_criminal_origin?: boolean;
  personal_data?: boolean;
  // Additional fields for "other" options
  [key: string]: string | boolean | number | undefined;
}

export class ProfileAPI {
  static updateProfile = async (data: {
    full_name?: string;
    avatar?: string;
  }): Promise<{
    success: boolean;
    user: UsersType;
  }> => api.post("/api/users/v1/profile", data);
}
